module.exports = __webpack_public_path__ + "media/PlatinumMiniPartnerBadge.static.7aabfe78a35fc2617c469f3cae3f74fc.svg";